import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'

import { initialiser } from './db/repo'
import { demanderPersistance, enregistrerServiceWorker } from './pwa/register'
import { App } from './ui/App'
import './ui/styles.css'

/**
 * `HashRouter` et non `BrowserRouter`.
 *
 * En mode standalone iOS, les URL profondes servies par le serveur sont une
 * source connue d'ecrans blancs au relancement de l'app. Le routage par
 * fragment est entierement gere cote client, ce qui supprime aussi le besoin
 * d'une regle de repli SPA cote Apache. Et un fragment n'etant jamais envoye
 * au serveur, aucun identifiant d'operation n'apparait dans les journaux.
 */
async function demarrer() {
  void demanderPersistance()
  enregistrerServiceWorker()

  const racine = document.getElementById('root')
  if (!racine) throw new Error('Element racine introuvable')

  try {
    await initialiser()
  } catch (e) {
    // Navigation privee de Safari, stockage bloque : l'app ne peut rien
    // conserver, autant le dire plutot que d'afficher un ecran vide.
    console.error(e)
    racine.textContent =
      "Le stockage local est indisponible (navigation privée ?). L'application ne peut pas enregistrer vos données."
    return
  }

  createRoot(racine).render(
    <StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
    </StrictMode>,
  )
}

void demarrer()
